module.exports = __webpack_public_path__ + "img/bob-pro.a0b86826.jpg";